module.exports = __webpack_public_path__ + "img/shape-metal_af-mobile@2x.b6758bfd.png";